import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_CREATE_GROUP_AMENDMENT_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../../api';

interface PostCreateAmendmentCommon {
  uuid: string;
}

interface Input {
  onSuccess?: (data: PostCreateAmendmentCommon) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateAmendment = ({ onSuccess, onError }: Input) => {
  const postCreateAmendment = async (payload: PostCreateAmendmentCommon) => {
    const res = await axiosClient.post<PostCreateAmendmentCommon>(
      POST_CREATE_GROUP_AMENDMENT_URL,
      payload
    );
    return res.data;
  };

  return useCustomMutation(postCreateAmendment, {
    onSuccess,
    onError,
  });
};
